import React from 'react';
import { categories, formatGestureForDisplay } from '../../utils/GestureCategories';

const RecordingSettings = ({
    gesture,
    handleGestureChange,
    selectedCategory,
    handleCategoryChange,
    isRecording,
    gestureError,
    isAdmin,
    showAllGestures = false,
    setShowAllGestures = () => {},
    sampleGestures = null,
    gestureCounts = {},
    onNextGesture = null,
    nextGestureDisabled = false,
    showNextButton = false,
}) => {
    return (
        <div className="recording-settings">
            <div className="gesture-selection-container">
                <select
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    disabled={isRecording}
                    className={`gesture-category-dropdown ${gestureError ? 'error' : ''}`}
                    style={gestureError ? { border: '2px solid red' } : {}}
                >
                    <option value="" disabled>
                        Select a gesture category
                    </option>
                    {categories.map((category) => (
                        <option key={category.id} value={category.id}>
                            {category.label}
                        </option>
                    ))}
                </select>

                {selectedCategory && (
                    <div className="gesture-dropdown-row">
                        <select
                            value={gesture}
                            onChange={handleGestureChange}
                            disabled={isRecording}
                            className={`gesture-dropdown ${gestureError ? 'error' : ''}`}
                            style={gestureError ? { border: '2px solid red' } : {}}
                        >
                            <option value="" disabled>
                                Select a gesture
                            </option>
                            {categories
                                .find((cat) => cat.id === selectedCategory)
                                ?.gestures
                                    .filter((g) => {
                                        const allowedBySample = sampleGestures === null || sampleGestures.includes(g);
                                        const notRecorded = (gestureCounts[g] || 0) === 0;
                                        return allowedBySample && (showAllGestures || notRecorded);
                                    })
                                    .map((g) => (
                                        <option key={g} value={g}>
                                            {formatGestureForDisplay(g)}
                                        </option>
                                    ))}
                        </select>
                        {isAdmin && (
                            <div className="show-all-toggle">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={showAllGestures}
                                        onChange={(e) => setShowAllGestures(e.target.checked)}
                                    />
                                    <span className="toggle-text">View All Gestures</span>
                                </label>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {showNextButton && (
                <button
                    className="next-gesture-button"
                    onClick={onNextGesture}
                    disabled={nextGestureDisabled}
                    title={nextGestureDisabled ? 'All gestures from this category have been completed.' : ''}
                >
                    Select Next Gesture
                </button>
            )}
        </div>
    );
};

export default RecordingSettings;
